import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { defer } from 'rxjs/observable/defer';
import * as configAction from './config.actions';
import { ConfigService } from './config.service';
import { Action } from '@ngrx/store';

import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ConfigEffects {

    @Effect() loadConfig$ = this.actions$
        .ofType(configAction.LOAD_REQUEST)
        .switchMap(() => this.config.load()
            .map(payload => (new configAction.LoadSuccessAction(payload)))
            // If request fails, dispatch failed action
            .catch(error => Observable.of(new configAction.LoadErrorAction(error)))
        );

    /**
     * Side effect to dispatch LoadRequestAction to load config.
     *
     * The order of Effect matter!
     * If this effect is before `loadConfig$` then the `loadConfig$` is not triggered!!!
     *
     * See https://github.com/ngrx/platform/blob/master/MIGRATION.md#init-action
     */
    @Effect()
    init$: Observable<Action> = defer(() => {
        return Observable.of(new configAction.LoadRequestAction());
    });

    constructor(private config: ConfigService, private actions$: Actions) {}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/config/config.effects.ts